export default __webpack_public_path__ + "static/media/stoquate_normal-available_loan.d4d52ddf.jpg";